/* eslint-disable max-len */
import React, {Component} from 'react';
import {Trans} from '@lingui/macro';
import {connect} from 'react-redux';
import { Link } from "react-router-dom";
// import AuthActions from 'bukku/redux/Auth/actions';
import {Menu, Popover} from 'antd';
// import AuthActions from 'bukku/redux/Auth/actions';
import UserActions from 'bukku/redux/User/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import UserPasswordViewDrawer from 'bukku/components/Drawer/UserPasswordView';
import UserViewDrawer from 'bukku/components/Drawer/UserView';
import {GlobalOutlined, LockOutlined, LogoutOutlined, UserOutlined} from '@ant-design/icons';
import {languageSwitcher} from "../../locales/i18n";
import styled from 'styled-components';
import { UserAvatarWithTooltip } from './topbarUser.Avatar';

// const { logout } = AuthActions;
const { updateUserLocale } = UserActions;

const Styled = styled.div`

    .avatar-round-border {
        position: absolute;
        top: -4px;
        left: -4px;
        width: 50px;
        height: 50px;
        content: '';
        border: 2.5px solid transparent;
        border-radius: 50%;

        &.blue {
            border-color: #1677ff /* blue-6 */
        }

        &.gold {
            border-color: #faad14; /* gold-6 */
        }

        &.green {
            border-color: #52c41a; /* green-6 */
        }
    }
    
`;
class TopbarUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            profileDrawerVisible: false,
            passwordDrawerVisible: false,
            languageMenuVisible: false,
        };
    }

    showProfileDrawer = () => {
        this.setState({ profileDrawerVisible: true });
    };

    closeProfileDrawer = () => {
        this.setState({ profileDrawerVisible: false });
    };

    showPasswordDrawer = () => {
        this.setState({ passwordDrawerVisible: true });
    };

    closePasswordDrawer = () => {
        this.setState({ passwordDrawerVisible: false });
    };

    handleVisibleChange = () => {
        this.setState(state => ({
            visible: !state.visible,
            // languageMenuVisible: false,
        }));
    };

    handleMenuClick = e => {
        const { updateUserLocale } = this.props;
        updateUserLocale({locale: e.key});
        this.setState({languageMenuVisible: false});
    };

    toggleLanguageMenu = e => {
        e.stopPropagation();
        e.preventDefault();
        this.setState(prevState => ({languageMenuVisible: !prevState.languageMenuVisible}));
    };

    getMenuItems = () => languageSwitcher.map(lang => ({
        key: lang.key,
        label: lang.value,
        className: 'topbar__language-menu-item',
    }));

    render() {
        const {
            user,
            // logout,
        } = this.props;
        const { passwordDrawerVisible, profileDrawerVisible, visible } = this.state;
        const { languageMenuVisible } = this.state;

        const localeObj = languageSwitcher.find(lang => lang.key === user.locale);
        const content = (
            <TopbarDropdownWrapper className="user" onClick={this.handleVisibleChange}>
                <span className="link" onClick={this.showProfileDrawer}>
                    <UserOutlined />
                    <Trans>My Profile</Trans>
                </span>
                <span className="link" onClick={this.showPasswordDrawer}>
                    <LockOutlined />
                    <Trans>Change Password</Trans>
                </span>
                <div className="divider" />
                <span className="link" onClick={this.toggleLanguageMenu}>
                    <GlobalOutlined />
                    {localeObj.value}
                    {/*<DownOutlined className="topbar__language-menu-down-icon" />*/}
                </span>
                <Menu
                    onClick={this.handleMenuClick}
                    selectedKeys={[user.locale]}
                    className={languageMenuVisible ? '' : 'none'}
                    items={this.getMenuItems()}
                />
                {/* { languageSwitcher.map(lang => (
                        <Menu.Item key={lang.key} className="topbar__language-menu-item">
                            {lang.value}
                        </Menu.Item>
                    ))}
                </Menu> */}

                {/*<span*/}
                {/*    className="link"*/}
                {/*    href="https://help.bukku.my"*/}
                {/*    target="_blank"*/}
                {/*>*/}
                {/*    <Trans>Help</Trans>*/}
                {/*    &nbsp;*/}
                {/*    (Coming Soon)*/}
                {/*</span>*/}

                <div className="divider" />
                {/* <span className="link" onClick={logout}>
                    <LogoutOutlined />
                    <Trans>Logout</Trans>
                </span> */}
                <span>
                    <Link to="/signin" className="link">
                        <LogoutOutlined />
                        <Trans>Logout</Trans>
                    </Link>
                </span>
            </TopbarDropdownWrapper>
        );

        return (
            <Styled>
                <UserPasswordViewDrawer
                    open={passwordDrawerVisible}
                    closeDrawer={this.closePasswordDrawer}
                />
                <UserViewDrawer
                    open={profileDrawerVisible}
                    closeDrawer={this.closeProfileDrawer}
                />

                <Popover
                    content={content}
                    trigger="click"
                    open={visible}
                    onOpenChange={this.handleVisibleChange}
                    arrow={{pointAtCenter: true}}
                    placement="bottomLeft"
                    destroyTooltipOnHide
                >
                    <div>
                        <UserAvatarWithTooltip
                            hasPopoverMenu={visible}
                        />
                    </div>
                </Popover>
            </Styled>
        );
    }
}
export default connect(state => ({
    user: state.Auth.user,
}), {
    // logout,
    updateUserLocale,
})(TopbarUser);
